import { INGRESADO, INICIADA_COMERCIO, GENERADO, RECHAZADA, PAGADO, TRANSFERIDO } from "../../cargarPresentacion/utilities/constants"
import { PresentacionState } from "../models/PresentacionState.model"

export const WebComerciosPath = "http://172.21.45.12/WebComercios" 


export const SUCCESS_GET_PRESENTACIONES = 'SUCCESS_GET_PRESENTACIONES'
export const FAILED_GET_PRESENTACIONES = 'FAILED_GET_PRESENTACIONES'
export const ERROR_GET_PRESENTACIONES = 'ERROR_GET_PRESENTACIONES'

export const SUCCESS_GET_DOWNLOAD_PDF = 'SUCCESS_GET_DOWNLOAD_PDF'
export const FAILED_GET_DOWNLOAD_PDF = 'FAILED_GET_DOWNLOAD_PDF'
export const ERROR_GET_DOWNLOAD_PDF = 'ERROR_GET_DOWNLOAD_PDF'

export const CMB_PRESENTATIONS:PresentacionState [] = [
    { label: 'Iniciada Comercio', short: 'INI', id: 4 },
    { label: 'Ingresado', short: 'ING', id: 1 },
    { label: 'Rechazada', short: 'REC', id: 5 },
    { label: 'Generado', short: 'GEN', id: 2 },
    { label: 'Transferido', short: 'TRA', id: 6 },
    { label: 'Pagado', short: 'PAG', id: 3 }
];

export const INIT_PRES_STATUSES = CMB_PRESENTATIONS.filter(c => [1, 4, 5].includes(c.id));
